import React from "react";

function ArrowsLeftIcon({ fill, ...restProps }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={fill ?? ""}
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M10.67 2.061c-.222.081-.42.248-.542.455-.092.156-.108.229-.107.484 0 .213.022.341.074.44.041.077.616.684 1.279 1.35L12.578 6H8.235c-4.714 0-4.553-.007-4.853.221-.08.061-.195.194-.254.295-.091.156-.108.23-.108.484 0 .256.016.328.111.489.125.213.318.375.539.454.122.043.975.054 4.529.055L12.578 8l-1.204 1.21c-.663.666-1.236 1.271-1.273 1.345-.229.454-.045 1.046.407 1.312.165.097.235.113.492.113.254 0 .328-.016.48-.107.225-.134 4.325-4.241 4.425-4.433.052-.099.074-.228.074-.44.001-.255-.015-.327-.106-.48-.06-.101-1.039-1.108-2.22-2.285-1.905-1.897-2.132-2.111-2.31-2.17a1 1 0 0 0-.673-.004m5 10c-.222.081-.42.248-.542.455-.092.156-.108.229-.107.484 0 .213.022.341.074.44.041.077.616.685 1.279 1.35L17.578 16h-6.843c-5.682 0-6.873.009-7.025.055a1.02 1.02 0 0 0-.582.461c-.091.156-.108.23-.108.484 0 .256.016.328.111.489.125.213.318.375.539.454.123.044 1.387.054 7.029.055l6.879.002-1.204 1.21c-.663.665-1.236 1.271-1.273 1.345-.229.454-.045 1.046.407 1.312.165.097.235.113.492.113.254 0 .328-.016.48-.107.225-.134 4.325-4.241 4.425-4.433.052-.099.074-.228.074-.44.001-.255-.015-.327-.106-.48-.06-.101-1.039-1.108-2.22-2.285-1.905-1.897-2.132-2.111-2.31-2.17a1 1 0 0 0-.673-.004"
        fill-rule="evenodd"
        fill={fill ?? ""}
      />
    </svg>
  );
}

export default ArrowsLeftIcon;
